import React from "react";
import Form from "../../../components/form";

import { FormControl } from "@mui/material";
import { FormLabel } from "@mui/material";
import { RadioGroup } from "@mui/material";
import { FormControlLabel } from "@mui/material";
import { Radio } from "@mui/material";

export default function RadioSituacao({ mudarSituacao, dados, contadores }) {
  const fSelect = {
    form: {
      cond: {
        label: "component",
        type: "component",
        value: (
          <FormControl>
            <FormLabel id="demo-row-radio-buttons-group-label">
              Situação*
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={dados.cond}
              onChange={mudarSituacao}
            >
              <FormControlLabel
                value="ABERTOS"
                control={<Radio />}
                label={`Em aberto (${
                  contadores.abertos ? contadores.abertos : 0
                })`}
              />
              <FormControlLabel
                value="ABERTOS_ANTIGOS"
                control={<Radio />}
                label={`Em aberto (antigos) (${
                  contadores.abertosAntigos ? contadores.abertosAntigos : 0
                })`}
              />
              <FormControlLabel
                value="FECHADOS"
                control={<Radio />}
                label={`Finalizados (${
                  contadores.finalizados ? contadores.finalizados : 0
                })`}
              />
              <FormControlLabel
                value="FECHADOS_COM_RESPOSTA"
                control={<Radio />}
                label={`Finalizados com resposta (${
                  contadores.finalizadosComRespostaProf
                    ? contadores.finalizadosComRespostaProf
                    : 0
                })`}
              />
              <FormControlLabel
                value=""
                control={<Radio />}
                label={`Todos (${contadores.total ? contadores.total : 0})`}
              />
            </RadioGroup>
          </FormControl>
        ),
      },
    },
  };
  return (
    <div>
      <Form formData={fSelect} />{" "}
    </div>
  );
}
